import React, { useState, useEffect } from 'react';
const Step2Details = ({
   formData,
   handleInputChange,
   handleSubmitStep1,
   isSubmitting,
   submitError,
   setCurrentStep,
   userData,
   userEmail
}) => {
   const [countries, setCountries] = useState([]);
   const [loadingCountries, setLoadingCountries] = useState(false);
   const [countryError, setCountryError] = useState(null);
   const [states, setStates] = useState([]);
   const [loadingStates, setLoadingStates] = useState(false);
   const [stateError, setStateError] = useState(null);
   // Modificar la función fetchCountries para ordenar los países
   useEffect(() => {
      const fetchCountries = async () => {
         setLoadingCountries(true);
         setCountryError(null);
         try {
            const jwt = localStorage.getItem('jwt');
            console.log('JWT:', jwt); // Verificar que el token existe
            const response = await fetch('https://pt-api.digit-a.net/api/catalogue/countries', {
               method: 'GET',
               headers: {
                  'Authorization': `Bearer ${jwt}`,
                  'Content-Type': 'application/json'
               }
            });
            if (!response.ok) {
               throw new Error(`Failed to fetch countries: ${response.status}`);
            }
            const data = await response.json();
            console.log('Response status:', response.status);
            console.log('Raw response:', data);

            if (Array.isArray(data)) {
               // Convertir el array de strings a array de objetos
               let formattedCountries = data.map(countryName => ({
                  code: countryName,
                  name: countryName
               }));

               // Ordenar los países para que Estados Unidos aparezca primero
               formattedCountries = formattedCountries.sort((a, b) => {
                  if (a.name === "United States") return -1;
                  if (b.name === "United States") return 1;
                  return a.name.localeCompare(b.name); // Ordenar el resto alfabéticamente
               });

               setCountries(formattedCountries);
            } else {
               throw new Error('Invalid data format received');
            }
         } catch (error) {
            console.error('Detailed error:', error);
            setCountryError(`Error loading countries: ${error.message}`);
         } finally {
            setLoadingCountries(false);
         }
      };

      fetchCountries();
   }, []);
   useEffect(() => {
      const fetchStates = async () => {
         if (formData.country !== 'United States') {
            setStates([]);
            return;
         }
         setLoadingStates(true);
         setStateError(null);
         try {
            const jwt = localStorage.getItem('jwt');
            // Enviamos el nombre completo del país
            const requestBody = {
               country: 'United States'
            };
            console.log('Request body:', requestBody);
            const response = await fetch('https://pt-api.digit-a.net/api/catalogue/states-by-country', {
               method: 'POST',
               headers: {
                  'Authorization': `Bearer ${jwt}`,
                  'Content-Type': 'application/json'
               },
               body: JSON.stringify(requestBody)
            });
            // Agregamos log para ver la respuesta cruda
            const responseText = await response.text();
            console.log('Raw response text:', responseText);
            if (!response.ok) {
               try {
                  const errorData = JSON.parse(responseText);
                  throw new Error(`Failed to fetch states: ${errorData.message || response.status}`);
               } catch (e) {
                  throw new Error(`Failed to fetch states: ${response.status} - ${responseText}`);
               }
            }
            const data = JSON.parse(responseText);
            console.log('States response:', data);
            if (Array.isArray(data)) {
               const formattedStates = data.map(stateName => ({
                  code: stateName,
                  name: stateName
               }));
               setStates(formattedStates);
            } else {
               throw new Error('Invalid state data format');
            }
         } catch (error) {
            console.error('Error fetching states:', error);
            setStateError('Error loading states');
         } finally {
            setLoadingStates(false);
         }
      };
      fetchStates();
   }, [formData.country]);
   return (
      <div className="modal_content_body">
         <h3 className="ppt_form_title mb-5 text-center">Step 1: Your Details</h3>
         {submitError && (
            <div className="alert alert-danger mb-4">
               {submitError}
            </div>
         )}
         <div className="row ppt_s2_fields">
            <div className="col-12 col-lg-6">
               <div className="ppt_input_style mb-4">
                  <label>First Name <abbr>*</abbr></label>
                  <div>
                     <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6">
               <div className="ppt_input_style mb-4">
                  <label>Last Name <abbr>*</abbr></label>
                  <div>
                     <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6">
               <div className="ppt_input_style mb-4">
                  <label>Email <abbr>*</abbr></label>
                  <div>
                     <input
                        type="email"
                        className="form-control"
                        placeholder={userEmail || 'Usuario'}
                        disabled
                        value={userData?.email || userEmail}
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6">
               <div className="ppt_input_style mb-4">
                  <label>Phone Number <abbr>*</abbr></label>
                  <div>
                     <input
                        type="tel"
                        className="form-control"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6">
               <div className="ppt_input_style mb-4">
                  <label>Country <abbr>*</abbr></label>
                  <div>
                     <select
                        className="form-select"
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        disabled={loadingCountries}
                     >
                        <option value="">Select a country</option>
                        {loadingCountries ? (
                           <option value="" disabled>Loading countries...</option>
                        ) : (
                           countries.map((country, index) => (
                              <option
                                 key={index}
                                 value={country.code}
                              >
                                 {country.name}
                              </option>
                           ))
                        )}
                     </select>
                     {countryError && (
                        <small className="text-danger">{countryError}</small>
                     )}
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6 ppt_s2_field_state">
               <div className="ppt_input_style mb-4">
                  <label>State <abbr>*</abbr></label>
                  <div>
                     <select
                        className="form-select"
                        name="state"
                        value={formData.country !== 'United States' ? '' : formData.state}
                        onChange={handleInputChange}
                        disabled={formData.country !== 'United States' || loadingStates}
                     >
                        <option value="">Select a state</option>
                        {loadingStates ? (
                           <option value="" disabled>Loading states...</option>
                        ) : (
                           states.map((state, index) => (
                              <option
                                 key={index}
                                 value={state.code || state}
                              >
                                 {state.name || state}
                              </option>
                           ))
                        )}
                     </select>
                     {stateError && (
                        <small className="text-danger">{stateError}</small>
                     )}
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6 ppt_s2_field_city">
               <div className="ppt_input_style mb-4">
                  <label>City <abbr>*</abbr></label>
                  <div>
                     <input
                        type="text"
                        className="form-control"
                        name="city"
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 col-lg-6 ppt_s2_field_zip">
               <div className="ppt_input_style mb-4">
                  <label>ZIP Code <abbr>*</abbr></label>
                  <div>
                     <input
                        type="text"
                        className="form-control"
                        name="zipCode"
                        value={formData.zipCode}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </div>
            <div className="col-12 ppt_s2_field_address">
               <div className="ppt_input_style mb-4">
                  <label>Address <abbr>*</abbr></label>
                  <div>
                     <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </div>
         </div>
         <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
            <button
               onClick={() => setCurrentStep(1)}
               className="ppt_btn_secondary alt text-dark"
               disabled={isSubmitting}
            >
               Back
            </button>
            <button
               onClick={handleSubmitStep1}
               className="ppt_btn_primary alt"
               disabled={
                  isSubmitting ||
                  !formData.firstName ||
                  !formData.lastName ||
                  !formData.phoneNumber ||
                  !formData.country ||
                  !formData.address ||
                  !formData.zipCode ||
                  (formData.country === 'United States' && !formData.state) // Solo validamos state si es United States
               }
            >
               {isSubmitting ? 'Submitting...' : 'Next'}
            </button>
         </div>
      </div>
   );
};
export default Step2Details;